"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const DayChangeMarker_1 = __importDefault(require("./DayChangeMarker"));
const Message_1 = __importStar(require("./Message"));
const dateFunctions_1 = require("../../utils/dateFunctions");
const MERGE_MESSAGES_SENT_BY_SAME_USER_WITHIN_MILLIS = 60 * 1000; // 1 minute
exports.default = react_1.default.memo(MessagesFromSingleDay);
const useStyles = makeStyles_1.default((theme) => ({
    dayContainer: {
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        paddingBottom: 14
    }
}));
function MessagesFromSingleDay(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const classes = useStyles();
    const theirUsername = (props.theirUserId && props.usersDictionary.hasOwnProperty(props.theirUserId))
        ? props.usersDictionary[props.theirUserId].username
        : null;
    // Determine which messages should be grouped with the previous message
    const messagesToGroup = [];
    let prevMessageSender = null;
    let lastMessageDate = null;
    for (const message of props.messages) {
        const senderUserId = message.kind === "unconfirmed" ? props.myUserId : message.sender;
        const groupWithPrevious = lastMessageDate !== null &&
            senderUserId === prevMessageSender &&
            message.date.getTime() - lastMessageDate.getTime() < MERGE_MESSAGES_SENT_BY_SAME_USER_WITHIN_MILLIS;
        messagesToGroup.push(groupWithPrevious);
        lastMessageDate = message.date;
        prevMessageSender = senderUserId;
    }
    const children = [];
    const startOfDay = dateFunctions_1.getStartOfDay(props.messages[0].date);
    children.push(react_1.default.createElement(DayChangeMarker_1.default, { key: startOfDay.toDateString(), date: startOfDay }));
    // Loop through messages and add components
    for (let i = 0; i < props.messages.length; i++) {
        const message = props.messages[i];
        let sentByMe;
        let senderUserId;
        let senderDetails = null;
        let readByMe = true;
        if (message.kind === "unconfirmed") {
            sentByMe = true;
            senderUserId = props.myUserId;
        }
        else {
            sentByMe = message.sender === props.myUserId;
            senderUserId = message.sender;
            readByMe = !props.unreadMessageDetector.isUnread(message);
            if (props.isGroupChat && !sentByMe) {
                senderDetails = props.usersDictionary.hasOwnProperty(message.sender)
                    ? props.usersDictionary[message.sender]
                    : {
                        userId: message.sender,
                        username: "Unknown",
                        version: 0
                    };
            }
        }
        const readByThem = !props.unreadMessageDetector.isUnreadByThem(message);
        const repliesToUserId = (_a = message.repliesTo) === null || _a === void 0 ? void 0 : _a.userId;
        const repliesToContent = (_c = (_b = message.repliesTo) === null || _b === void 0 ? void 0 : _b.content) !== null && _c !== void 0 ? _c : null;
        const repliesToMyMessage = props.myUserId === repliesToUserId;
        const repliesToUsername = repliesToUserId && !repliesToMyMessage && props.usersDictionary.hasOwnProperty(repliesToUserId)
            ? props.usersDictionary[repliesToUserId].username
            : null;
        // Determine whether the message should be grouped with others and if so whether it is
        // at the top, middle, or bottom of the group
        const groupWithPrevious = messagesToGroup[i];
        const groupWithNext = i < props.messages.length - 1 ? messagesToGroup[i + 1] : false;
        let groupPosition = Message_1.MessageGroupPosition.None;
        if (!groupWithPrevious && groupWithNext) {
            groupPosition = Message_1.MessageGroupPosition.Top;
        }
        else if (groupWithPrevious && groupWithNext) {
            groupPosition = Message_1.MessageGroupPosition.Middle;
        }
        else if (groupWithPrevious && !groupWithNext) {
            groupPosition = Message_1.MessageGroupPosition.Bottom;
        }
        const messageId = "id" in message ? message.id : null;
        const selectEffect = messageId != null && props.messageIdToSelect != null && messageId === props.messageIdToSelect;
        children.push(react_1.default.createElement(Message_1.default, { key: message.clientMessageId, chatId: props.chatId, messageId: messageId, userId: senderUserId, clientMessageId: message.clientMessageId, content: message.content, date: message.date, isGroupChat: props.isGroupChat, sentByMe: sentByMe, sender: senderDetails, theirUsername: theirUsername, confirmed: message.kind !== "unconfirmed", readByMe: readByMe, readByThem: readByThem, groupPosition: groupPosition, repliesToContent: repliesToContent, repliesToChatId: (_e = (_d = message.repliesTo) === null || _d === void 0 ? void 0 : _d.chatId) !== null && _e !== void 0 ? _e : null, repliesToMessageId: (_g = (_f = message.repliesTo) === null || _f === void 0 ? void 0 : _f.messageId) !== null && _g !== void 0 ? _g : null, repliesToMyMessage: repliesToMyMessage, repliesToUsername: repliesToUsername, selectEffect: selectEffect }));
    }
    return (react_1.default.createElement("div", { className: classes.dayContainer }, children));
}
